<script setup></script>

<template>
  <section class="container my-10 overflow-hidden">
    <!-- Mobile SVG -->
    <svg
      class="w-full h-full md:hidden bg-bg-dark"
      viewBox="0 0 336 640"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- Background fill -->
      <rect
        x="2"
        y="2"
        width="332"
        height="636"
        fill="url(#pattern0_447_6580)"
        fill-opacity="0.7"
      />
      <!-- Diagonal crossed lines -->
      <path
        d="M2 2L334 638"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
      />
      <path
        d="M334 2L2 638"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
      />
      <!-- Store locator text -->
      <text
        x="168"
        y="320"
        text-anchor="middle"
        fill="#E6D8FF"
        font-family="monospace"
        font-size="12"
      >
        HOODIE ANALYTICS
      </text>
      <text
        x="168"
        y="340"
        text-anchor="middle"
        fill="#E6D8FF"
        font-family="monospace"
        font-size="12"
      >
        STORE LOCATOR
      </text>
      <!-- Border rectangle -->
      <rect
        x="1"
        y="1"
        width="334"
        height="638"
        rx="13"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
        fill="none"
      />
      <defs>
        <pattern
          id="pattern0_447_6580"
          patternUnits="userSpaceOnUse"
          patternTransform="matrix(12.8 0 0 12.8 2 2)"
          preserveAspectRatio="none"
          viewBox="0 0 16 16"
          width="1"
          height="1"
        >
          <g id="pattern0_447_6580_inner">
            <rect width="2" height="2" fill="white" fill-opacity="0.1" />
          </g>
        </pattern>
      </defs>
    </svg>

    <!-- Desktop SVG -->
    <svg
      class="w-full h-full hidden md:block bg-bg-dark -mb-[40%]"
      viewBox="0 0 1440 1356"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_205_2867)">
        <rect
          x="48"
          y="120"
          width="1344"
          height="636"
          fill="url(#pattern0_205_2867)"
          fill-opacity="0.7"
        />
      </g>
      <!-- Diagonal crossed lines -->
      <path
        d="M48 120L1392 756"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
      />
      <path
        d="M1392 120L48 756"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
      />
      <!-- Border rectangle -->
      <rect
        x="47"
        y="119"
        width="1346"
        height="638"
        rx="13"
        stroke="#756AAF"
        stroke-width="2"
        stroke-dasharray="2 6"
        fill="none"
      />
      <defs>
        <clipPath id="clip0_205_2867">
          <rect x="48" y="120" width="1344" height="636" rx="12" fill="white" />
        </clipPath>
        <pattern
          id="pattern0_205_2867"
          patternUnits="userSpaceOnUse"
          patternTransform="matrix(12.8 0 0 12.8 48 120)"
          preserveAspectRatio="none"
          viewBox="0 0 16 16"
          width="1"
          height="1"
        >
          <g id="pattern0_205_2867_inner">
            <rect width="2" height="2" fill="white" fill-opacity="0.1" />
          </g>
        </pattern>
      </defs>
    </svg>

    <span
      class="absolute-x-center md:block hidden bottom-[40%] text-text-base font-body text-body-lg font-medium leading-4 tracking-[1.12px] uppercase"
    >
      Hoodie Analytics Store Locator
    </span>
  </section>
</template>
